<template>
  <div
    class="add d-flex align-items-center justify-content-center"
    :class="view === 1 ? 'pointer' : ''"
    @click="firstClick()"
  >
    <div
      v-if="view === 1"
      class="text-center"
    >
      <img :src="`${$publicPath}img/campaigns/add_file.svg`"><br>
      <span class="add-file-text">{{ $t('view-CampaignsFiles.add-file') }}</span>
    </div>
    <div v-if="view === 2">
      <div
        v-if="type === null"
        class="text-center"
      >
        <std-button
          add-class="my-1"
          type="C"
          :title="$t('view-CampaignsFiles.file')"
          @click="() => { type = 'file'; value = null; }"
        />
        <std-button
          add-class="my-1"
          type="C"
          :title="$t('view-CampaignsFiles.link')"
          @click="() => { type = 'url'; value = null; }"
        />
      </div>
      <div
        v-if="type === 'file'"
        class="text-center w90"
      >
        <b-form-file
          v-model="value"
          :state="Boolean(value)"
          placeholder=""
          browse-text="+"
        />
        <div
          v-if="buttonLoader"
          class="d-flex justify-content-center mt-2"
        >
          <b-spinner
            label="Spinner"
            class="loader"
          />
        </div>
        <div
          v-else
          class="d-flex justify-content-between mt-2"
        >
          <div
            class="cancel-btn"
            :style="`background-image: url(${$publicPath}img/campaigns/x.svg)`"
            @click="type = null"
          />
          <div
            class="send-btn"
            :style="`background-image: url(${$publicPath}img/campaigns/ok.svg)`"
            @click="send()"
          />
        </div>
      </div>
      <div
        v-if="type === 'url'"
        class="text-center w90"
      >
        <b-form-input
          v-model="value"
          :state="Boolean(value)"
        />
        <div
          v-if="buttonLoader"
          class="d-flex justify-content-center mt-2"
        >
          <b-spinner
            label="Spinner"
            class="loader"
          />
        </div>
        <div
          v-else
          class="d-flex justify-content-between mt-2"
        >
          <div
            class="cancel-btn"
            :style="`background-image: url(${$publicPath}img/campaigns/x.svg)`"
            @click="type = null"
          />
          <div
            class="send-btn"
            :style="`background-image: url(${$publicPath}img/campaigns/ok.svg)`"
            @click="send()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    member: {
      type: Object,
      default: () => { return {} }
    },
    message: {
      type: Object,
      default: () => { return {} }
    }
  },
  data: function () {
    return {
      view: 1,
      buttonLoader: false,
      type: null,
      value: null
    }
  },
  methods: {
    firstClick () {
      if (this.view === 1) {
        this.view = 2
      }
    },
    send () {
      if (!this.value || this.buttonLoader) {
        return
      }

      this.buttonLoader = true
      const data = {
        memberId: this.member.id,
        data: {
          type: this.type,
          value: this.value
        }
      }
      this.$store.dispatch('campaignsFiles/addFile', data)
        .then(() => {
          this.$flash.success(this.$t('view-CampaignsFiles.message.success'))
          this.type = null
          this.view = 1
          this.buttonLoader = false
          /* reload campaign for status change */
          this.$store.dispatch('campaignsInfluencer/getOne', this.member.campaign_id).catch(e => {})
        }).catch((e) => {
          if (e.response.status === 422) {
            this.$flash.error(this.$t(e.response.body.errors[0]))
          } else {
            this.$flash.error(this.$t('view-CampaignsFiles.message.error'))
          }
          this.buttonLoader = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .send-btn, .cancel-btn {
    display: inline-block;
    padding: 1rem;
    border-radius: 5px;
    background-color: #fafafa;
    border: solid $nh-gray 1px;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .pointer {
    cursor: pointer;
  }
  .add {
    background-color: #fafafa;
    border-radius: 5px;
    border: dashed $nh-gray 2px;
    img{
      width: 35px;
    }
    &:after {
      content: "";
      display: block;
      padding-bottom: 100%;
    }
  }
  ::v-deep {
    .nh-btn {
      display: inline-block;
      min-width: 90%;
    }
    label {
      cursor: pointer;
    }
  }
  .w90 {
    width: 90%;
    margin-left: 5%;
  }
  .add-file-text {
    font-size: 0.75rem;
    font-weight: 600;
  }
</style>
